module.exports = __webpack_public_path__ + "src/assets/img/s-geo_w.6f98f2a9.svg";